import { render, staticRenderFns } from "./Applianceswidget.vue?vue&type=template&id=c1f81524"
import script from "./Applianceswidget.vue?vue&type=script&lang=js"
export * from "./Applianceswidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports